import { render, staticRenderFns } from "./wait-list.vue?vue&type=template&id=217ef667&"
import script from "./wait-list.vue?vue&type=script&lang=js&"
export * from "./wait-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports